import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CommitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"commit"}/>
}
